import { AssertionError } from "./AssertionError.js";
function assert(that = void 0, value, predicate) {
  if (!predicate(value)) {
    throw new AssertionError(value, that);
  }
}
export {
  assert
};
//# sourceMappingURL=assert.js.map
